/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState} from "react";
import Navbar from "react-bootstrap/Navbar";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu";
import "../index.css";
export default function Navheader(props) {
    const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if(window.scrollY >= 10){
      setNavbar(true);
    }else{
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <>
        <Navbar
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar' }
        >
          <Navbar.Brand>
            <a href="https://www.swmc.com/" target="_blank" rel="noreferrer">
              <img
                src="https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
                className=" img-fluid w-50 main_logo"
                alt="swmc-logo"
              />
            </a>
          </Navbar.Brand>
            <UserWayAccessibilityMenu color="white" width={40} height={40}/>
        </Navbar>

    </>
  );
}
